export const GET_MUNICIPALITIES = 'GET_MUNICIPALITIES';
export const GET_MUNICIPALITY = 'GET_MUNICIPALITY';
